// src/utils/plans.js

const PIANI = {
  base: {
    import_csv_diretto: false,
    modifica_descrizione_nomi_conto: false,
    modifica_anagrafica: false,
    archivio_completo_nomi_conto: false,
    funzione_carica_piano: false,
    condivisione_pdc_studio: false,
    cronologia_operazioni: false,
    suggerimenti_intelligenti: false,
    cronologia_illimitata: false,
    archivio_scaricabile_file_convertiti: false,
  },

  plus: {
    import_csv_diretto: true,
    modifica_descrizione_nomi_conto: true,
    modifica_anagrafica: true,
    archivio_completo_nomi_conto: true,
    funzione_carica_piano: true,
    condivisione_pdc_studio: true,
    cronologia_operazioni: true,
    suggerimenti_intelligenti: false,
    cronologia_illimitata: false,
    archivio_scaricabile_file_convertiti: false,
  },

  premium: {
    import_csv_diretto: true,
    modifica_descrizione_nomi_conto: true,
    modifica_anagrafica: true,
    archivio_completo_nomi_conto: true,
    funzione_carica_piano: true,
    condivisione_pdc_studio: true,
    cronologia_operazioni: true,
    suggerimenti_intelligenti: true,
    cronologia_illimitata: true,
    archivio_scaricabile_file_convertiti: true,
  },
};

export function haFunzionalita(user, feature) {
  if (!user || !user.studio || !user.studio.piano) {
    return PIANI.base[feature] ?? false;
  }

  const piano = user.studio.piano.toLowerCase(); // ← "plus", "premium", "base"
  const permessi = PIANI[piano] || PIANI.base;
  return permessi[feature] ?? false;
}

export function haPiano(pianoNome, feature) {
  const piano = (pianoNome || "base").toLowerCase();
  const permessi = PIANI[piano] || PIANI.base;
  return permessi[feature] ?? false;
}
export function isPiano(user, pianoCercato) {
  if (!user || !user.studio || !user.studio.piano) return false;
  return user.studio.piano.toLowerCase() === pianoCercato.toLowerCase();
}
// Esporto anche la matrice grezza se ti serve per debug
export { PIANI };
